import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { store } from './store';
import ErrorBoundary from './submodules/shared/components/error-boundary/error-boundary';
import AppContainer from './views/app';
// Compiled CSS (not the SCSS source): Vite rebases url() font references in
// plain CSS imports, but has no resolve-url-loader for SCSS-inlined ones.
import 'font-awesome/css/font-awesome.min.css';
import './index.scss';

// Root boundary inside <Provider> so the fallback can dispatch through reportError.
// StrictMode is dev-only (no production behavior) and surfaces unsafe effects /
// lifecycles under React 18; see XHYD-1890.
const root = createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <ErrorBoundary name="root">
                <AppContainer />
            </ErrorBoundary>
        </Provider>
    </React.StrictMode>,
);
